export default __webpack_public_path__ + "static/media/trackingContainers1.c59f3f27.jpg";